export default {
    // --------Title--------
    statesAndAreas: 'States & Areas',
    definePreciseLocation: 'Define precise location',
    youHaveNotmakeAnySelection: 'You have not make any selection',

    // --------Drawer--------
    newArea: 'New Area',
    updateArea: 'Update Area',

    // --------MUI--------
    sortName: 'Sort Name',
    phoneCode: 'Phone Code',
    states: 'States',
    areas: 'Areas'

};